// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__3Jmgg","wide":"Content_wide__NQ0j3 Content_content__3Jmgg"};